import { render } from "./NimbusTextarea.vue?vue&type=template&id=6293b3c7"
import script from "./NimbusTextarea.vue?vue&type=script&lang=js"
export * from "./NimbusTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__